import type { FC, ReactNode, MouseEvent } from 'react';
import { memo } from 'react';
import { Spin } from 'antd';
type IconButtonProps = {
  icon: ReactNode;
  onClick?: (ev: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  dataValue?: string;
  content?: string | boolean;
  disabled?: boolean;
  isLoading?: boolean;
  contentClassName?: string;
};
export const IconButton: FC<IconButtonProps> = memo(
  ({
    icon: Icon,
    onClick,
    className,
    content,
    dataValue,
    disabled,
    isLoading,
    contentClassName,
  }) => {
    return (
      <button
        onClick={onClick}
        className={className}
        data-value={dataValue}
        disabled={disabled}
      >
        {isLoading ? (
          <Spin spinning />
        ) : (
          <>
            {Icon}
            {content && <span className={contentClassName}>{content}</span>}
          </>
        )}
      </button>
    );
  },
);
